<footer class="pe-5 d-flex align-items-center justify-content-end">
  TotalEnergies - MultiProduct Studio {{currentYear}} ©
</footer>
